import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBasketShopping, faCubes, faUsers } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FrontEndRoutes } from "../config/front-end-routes";
import DashboardCounters from "../Components/Counters/DashboardCounters";
import {BackEndRoutes} from "../config/back-end-routes";

interface DataResponse {
    id: number;
    title: string;
    body: string;
}

const Home: React.FC = () => {
    const [clients, setClients] = useState<number>(0);
    const [productsSold, setProductsSold] = useState<number>(0);
    const [pendingOrders, setPendingOrders] = useState<number>(0);
    const [importedOrders, setImportedOrders] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleClients = () => navigate(FrontEndRoutes.CLIENTES.LIST);
    const handleProducts = () => navigate(FrontEndRoutes.PRODUTOS.LIST);
    const handleShopping = () => navigate(FrontEndRoutes.PEDIDOS.LIST);

    useEffect(() => {
        axios.get(BackEndRoutes.routes.DASH_DATA)
            .then((response) => {
                const { clients, productsSold, pendingOrders, importedOrders } = response.data;
                setClients(clients);
                setProductsSold(productsSold);
                setPendingOrders(pendingOrders);
                setImportedOrders(importedOrders);
            })
            .catch((error) => console.error('Erro ao buscar os dados do dashboard:', error));
    }, []);

    return (
        <div className="d-flex flex-column gap-5 h-100">
            <div className=" py-3">
                <Container>
                    <DashboardCounters
                        clients={clients}
                        productsSold={productsSold}
                        pendingOrders={pendingOrders}
                        importedOrders={importedOrders}
                    />
                </Container>
            </div>
            <div className="d-flex align-items-center justify-content-center">
                <Container className="d-flex flex-column gap-3">
                    {loading ? (
                        <div className="text-center my-5">
                            <Spinner animation="border" variant="primary" />
                            <p>Carregando dados...</p>
                        </div>
                    ) : (
                        <Row className="d-flex justify-content-center align-items-center gap-3">
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ height: '120px', width: '120px', borderRadius: '8px', cursor: "pointer", background: '#3490dc' }}
                                onClick={handleClients}
                            >
                                <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faUsers} size="2x" className="text-white" />
                                    <span className="text-white">Clientes</span>
                                </div>
                            </div>
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ height: '120px', width: '120px', borderRadius: '8px', cursor: "pointer", background: '#3490dc' }}
                                onClick={handleProducts}
                            >
                                <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faCubes} size="2x" className="text-white" />
                                    <span className="text-white">Produtos</span>
                                </div>
                            </div>
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ height: '120px', width: '120px', borderRadius: '8px', cursor: "pointer", background: '#3490dc' }}
                                onClick={handleShopping}
                            >
                                <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                    <FontAwesomeIcon icon={faBasketShopping} size="2x" className="text-white" />
                                    <span className="text-white">Pedidos</span>
                                </div>
                            </div>
                        </Row>
                    )}
                </Container>
            </div>
        </div>
    );
};

export default Home;
